import SplitToggleButton from '~/components/Buttons/SplitToggleButton';
import BrushToolDailog from './BrushToolDialog';
import { Brush } from 'lucide-react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { brushOptionsState, selectedToolState } from '~/state/atoms/toolsAtoms';
import { Stack } from '@mui/material';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function BrushToolComponent() {
    const [tool, setTool] = useRecoilState(selectedToolState);
    const primaryImage = useRecoilValue(primaryImageState);
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const setBrushOptions = useSetRecoilState(brushOptionsState);
    const [validationError, setValidationError] = useState<string | null>(null);
    const isDisabled =
        !selectedStructureSet || selectedStructureSet.roiArray.length === 0;

    useEffect(() => {
        if (validationError) {
            enqueueSnackbar(validationError, { variant: 'error' });
            setValidationError(null);
        }
    }, [validationError]);

    const handleToolSelect = () => {
        const isDatasetTilted = primaryImage?.firstSlice.tilted;
        if (isDatasetTilted) {
            setValidationError(
                'Brush tool is not available for tilted datasets'
            );
            return;
        }
        setTool('brush');
        setBrushOptions((options) => ({
            ...options,
            erase: false,
        }));
    };

    return (
        <SplitToggleButton
            isSelected={tool === 'brush'}
            value="brush"
            onToggle={() => handleToolSelect()}
            icon={<Brush />}
            tooltipTitle="Brush"
            popperComponent={
                <Stack p={2} gap={2}>
                    <BrushToolDailog />
                </Stack>
            }
            disabled={isDisabled}
        />
    );
}
